import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/components/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/link.tsx");
